// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WavePointSvg from '@rsuite/icon-font/lib/charts/WavePoint';
var WavePoint = createSvgIcon({
  as: WavePointSvg,
  ariaLabel: 'wave point',
  category: 'charts',
  displayName: 'WavePoint'
});
export default WavePoint;